<template>
    <div class="">
        <give-welcome-bg/>
        <give-a-gift/>
        <rescue-call/>
        <give-stories/>

        <upcoming-events/>
        <!--Add feature stories-->
    </div>
</template>

<script>
    import GiveWelcomeBg from "../components/give/GiveWelcomeBg";
    import GiveAGift from "../components/give/giveAGift";
    import RescueCall from "../components/give/rescueCall";
    import GiveStories from "../components/give/giveStories";
    import UpcomingEvents from "../components/home/upcomingEvents";
    export default {
        name: "Give",
        components: {UpcomingEvents, GiveStories, RescueCall, GiveAGift, GiveWelcomeBg}
    }
</script>

<style scoped>

</style>